<template>
  <div class="event-Details">
    <div :class="isPc ? 'event-Details-wrap' : ''">
      <ApprovalDetails
        v-if="type === 0 && result.storeName"
        :isRightIcon="false"
        :data="result"
        @seeDetails="type = 1"
      />
      <Details
        v-if="type === 1 && result.storeName"
        :isRightIcon="false"
        :data="result"
        :type="detailsType"
        @back="type = 0"
        @goDetailsClick="goDetailsClick"
        @setDetailsType="setDetailsType"
      />
      <FollowUpDetails
        :data="followUpDetailsItem"
        :isRightIcon="false"
        v-if="type === 2"
        @back="type = 1"
      />
    </div>
  </div>
</template>

<script>
import { eventReport } from "@/api/request";
import Details from "../event/children/Details.vue";
import FollowUpDetails from "../event/children/FollowUpDetails";
import ApprovalDetails from "../event/children/ApprovalDetails";
export default {
  components: {
    Details,
    FollowUpDetails,
    ApprovalDetails,
  },
  data() {
    return {
      type: 0,
      result: {},
      followUpDetailsItem: {},
      isPc: true,
      tenant: "",
      eventRecordId: "",
      detailsType:true
    };
  },
  created() {
    this.tenant = this.$route.query.tenant;
    this.eventRecordId = this.$route.query.eventRecordId;
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
      // alert('移动端')
      this.isPc = false;
    } else {
      // alert('pc端')
      this.isPc = true;
    }
    this.eventReport();
  },
  methods: {
    eventReport() {
      eventReport({
        tenant: this.tenant,
        eventRecordId: this.eventRecordId,
      }).then((res) => {
        res.data.flow.forEach((item) => {
          this.$set(item, "openOrPutawayType", false);
          item.checkNodes.forEach((item) => {
            this.$set(item, "openOrPutawayType", false);
          });
        });
        this.result = res.data;
        if (this.result.state === 1) {
          this.type = 1;
        } else {
          this.type = 0;
        }
      });
    },
    goDetailsClick(item) {
      this.type = 2;
      this.followUpDetailsItem = item;
    },
    setDetailsType(value) {
      this.detailsType = value
    },
  },
};
</script>

<style lang="less" scope>
.event-Details {
  width: 100%;
  height: 100%;
  background-color: #f4f5f7;
  .event-Details-wrap {
    width: 375px;
    margin: 0 auto;
    height: 800px;
    overflow: auto;
    border: 2px solid #e7f1fe;
  }
}
</style>